import { initialAppState } from './app.state';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { envConfig } from '../config/environment';
import { LoggerService } from '../logging/logger.service';

export const AppStore = signalStore(
    {providedIn: 'root'},
    withState(initialAppState),
    withMethods((store) => {
        const platformId = inject(PLATFORM_ID);
        const logger = inject(LoggerService);
        const isDevBrowser = isPlatformBrowser(platformId) && !envConfig.isProd;

        return {
            initializeLogging() {
                patchState(store, { isDebugLoggingEnabled: isDevBrowser })
                logger.info('AppStore', 'Logging initialized', { debugEnabled: isDevBrowser });
            },

            setTheme(theme: 'light' | 'dark') {
                patchState(store, { theme });
                logger.debug('AppStore', 'Theme changed', { theme });
            }
        }
    })
)

